'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// TODO(FVENDOR-6563): implement on state machine with access to promises

/**
 * Stores inner state of paginated ValueLink collection
 */
var PagedCollectionState = Nested.Model.extend({

    /**
     * syncInProgress: equal TRUE, when synchronization going, and FALSE by end of synchronization
     * syncSuccess: equal FALSE, when synchronization not started yet or fails,
     *              equal TRUE, when synchronization succeed
     * totalPages: count of available pages for pagination,
     *             will be equal 0, when synchronization not ends or failed
     * totalElements: count of found element, will be equal 0, when synchronization not ends or failed
     *
     * for internal usage only:
     *   syncPromise: promise for synchronization work
     *                (non-null and mutable, look to sync method in pagedCollectionFactory.js)
     *   syncErrorResponse: will be filled if promise failed
     */
    defaults: {
        syncInProgress: Boolean.value(false),
        syncSuccess: Boolean.value(false),
        totalPages: Number.value(0),
        totalElements: Number.value(0),
        syncPromise: Nested.value(null),
        syncErrorResponse: Nested.value(null)
    },

    _startSync: function _startSync(syncPromise) {
        this.set({
            syncInProgress: true,
            syncSuccess: false,
            syncPromise: syncPromise,
            syncErrorResponse: null,
            totalPages: 0,
            totalElements: 0
        });
    },
    _syncCompleteSuccess: function _syncCompleteSuccess(response) {
        var page = response.body.page;

        this.set({
            syncInProgress: false,
            syncSuccess: true,
            syncErrorResponse: null,
            totalPages: page ? page.totalPages : 1,
            totalElements: page ? page.totalElements : null
        });
    },
    _syncCompletedWithError: function _syncCompletedWithError(response) {
        this.set({
            syncInProgress: false,
            syncSuccess: false,
            syncErrorResponse: response,
            totalPages: 0,
            totalElements: 0
        });
    }
});

exports.default = PagedCollectionState;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/paged/PagedCollectionState.js
// module id = 1417
// module chunks = 118